import { InputNumber } from 'component/Input/InputNumber'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { formatNumber } from 'util/number'

export const MinPriceInput = observer(() => {
  const { form, options } = useDemo()
  const { min_price, max_price } = form
  const { tsum_min_price, tsum_max_price } = options
  const min = tsum_min_price
  const max = tsum_max_price
  const placeholder = i18n('PriceFrom', { count: formatNumber(min) })

  const onChange = useLatestCallback((value: number | undefined) => {
    if (!value) {
      form.min_price = null
      return
    }
    value = Math.max(min, Math.min(max, value))
    form.min_price = value
    if (max_price && max_price <= value) form.max_price = value
  })

  return <InputNumber upper value={min_price} placeholder={placeholder} onChange={onChange} />
})
